import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    max_depth_date: "",
    product_ids_slice: {},
};

const slicesAnalyticsSlice = createSlice({
    name: "slicesAnalytics",
    initialState,
    reducers: {
        setMaxDepthDate: (state, action) => {
            state.max_depth_date = action.payload;
        },
        setProductIdsSlice: (state, action) => {
            const { table_key, product_ids } = action.payload; 
            state.product_ids_slice[table_key] = product_ids; 
        },
    },
});

export default slicesAnalyticsSlice.reducer;

export const {
    setMaxDepthDate,
    setProductIdsSlice
} = slicesAnalyticsSlice.actions;